/**
 * Search Drawer — HomeDock Premium
 * Shopify Predictive Search API + sistema de sinônimos para SEO orgânico
 */

(() => {
  'use strict';

  /* ================================================================
     DICIONÁRIO DE SINÔNIMOS
     Chave = termo canônico (como aparece nos produtos/coleções)
     Valor = array de variações orgânicas em português
  ================================================================ */
  const SYNONYMS = {
    'conjunto de jantar': [
      'conjunto jantar',
      'mesa com cadeiras',
      'mesa jantar cadeiras',
      'mesa de jantar com cadeiras',
      'mesa sala jantar',
      'mesa e cadeiras',
      'conjunto mesa cadeira',
      'mesa jantar',
      'conjunto sala de jantar',
      'mesa jantar e cadeiras',
      'conjunto mesa e cadeiras',
      'conjunto jantar completo',
      'kit jantar',
      'kit de jantar',
      'jogo jantar',
      'jogo de jantar',
      // variações "mesa X cadeiras"
      'mesa 4 cadeiras',
      'mesa 6 cadeiras',
      'mesa 8 cadeiras',
      'mesa 10 cadeiras',
      'mesa 12 cadeiras',
      'mesa com 4 cadeiras',
      'mesa com 6 cadeiras',
      'mesa com 8 cadeiras',
      'mesa com 10 cadeiras',
      'mesa 4 lugares e cadeiras',
      'mesa 6 lugares e cadeiras',
      'mesa 8 lugares e cadeiras',
      'conjunto 4 cadeiras',
      'conjunto 6 cadeiras',
      'conjunto 8 cadeiras',
      'conjunto 4 lugares',
      'conjunto 6 lugares',
      'conjunto 8 lugares',
      'conjunto 10 lugares',
      'mesa redonda 4 cadeiras',
      'mesa redonda 6 cadeiras',
      'mesa retangular 6 cadeiras',
      'mesa retangular 8 cadeiras',
      'mesa jantar 4 cadeiras',
      'mesa jantar 6 cadeiras',
      'mesa jantar 8 cadeiras',
      '4 cadeiras',
      '6 cadeiras',
      '8 cadeiras',
      'sala de jantar completa',
      'sala jantar completa',
      'mobilia jantar',
      'mobília jantar',
      'moveis jantar',
      'móveis jantar',
      'conjunto moveis jantar',
      'conjunto mobilia sala de jantar',
    ],

    'mesa de jantar': [
      'mesa jantar',
      'mesa sala',
      'mesa redonda jantar',
      'mesa retangular jantar',
      'mesa quadrada jantar',
      'mesa 4 lugares',
      'mesa 6 lugares',
      'mesa 8 lugares',
      'mesa 10 lugares',
      'mesa para jantar',
      'mesa de madeira jantar',
      'mesa organica',
      'mesa orgânica',
      'mesa pedestal',
      'mesa tampo vidro',
      'mesa tampo madeira',
      'mesa ripada',
      'mesa rustica',
      'mesa rústica',
      'mesa moderna',
      'mesa oval',
      'mesa circular',
      'mesa de madeira',
      'mesa de madeira solida',
      'mesa madeira maciça',
      'mesa jantar madeira',
      'mesa sala de jantar',
    ],

    'cadeira de jantar': [
      'cadeiras jantar',
      'cadeira para mesa',
      'cadeira sala jantar',
      'banco mesa jantar',
      'cadeira cozinha',
      'cadeira para sala de jantar',
      'cadeira estofada',
      'cadeira moderna',
      'cadeira boucle',
      'cadeira bouclé',
      'cadeira madeira',
      'cadeira veludo',
      'cadeira linho',
      'cadeira couro',
      'cadeira couro ecologico',
      'cadeira couro ecológico',
      'cadeira branca',
      'cadeira preta',
      'cadeira bege',
      'cadeira cinza',
      'cadeira com braço',
      'cadeira sem braço',
      'cadeira acento estofado',
      'cadeira de madeira',
      'cadeira jantar branca',
      'cadeira jantar preta',
    ],

    'sofa': [
      'sofá',
      'sofa sala',
      'sofa 2 lugares',
      'sofa 3 lugares',
      'sofa 4 lugares',
      'sofá 2 lugares',
      'sofá 3 lugares',
      'sofa retratil',
      'sofa retrátil',
      'sofa reclinavel',
      'sofa reclinável',
      'sofa retratil reclinavel',
      'sofa retratil e reclinavel',
      'sofa cama',
      'sofá cama',
      'sofa grande',
      'sofa modular',
      'sofa chaise',
      'sofa l',
      'sofa em l',
      'sofá em l',
      'sofá chaise',
      'sofa de canto',
      'estofado',
      'estofados',
      'sofa suede',
      'sofa boucle',
      'sofa bouclé',
      'sofa veludo',
      'sofa linho',
      'sofa couro',
      'sofa tecido',
      'sofa cinza',
      'sofa bege',
      'sofa preto',
      'sofa branco',
      'sofa moderno',
      'sofa grande sala',
      'sofa familia',
      'sofa com chaise',
      'sofa com puf',
      'sofa retrátil reclinável',
    ],

    'poltrona': [
      'poltrona sala',
      'cadeira sala',
      'poltrona decorativa',
      'poltrona leitura',
      'poltrona conforto',
      'cadeira decorativa sala',
      'poltrona individual',
      'poltrona moderna',
      'poltrona boucle',
      'poltrona bouclé',
      'poltrona veludo',
      'poltrona giratoria',
      'poltrona giratória',
      'poltrona com puff',
      'poltrona com pufe',
      'poltrona reclinavel',
      'poltrona reclinável',
      'cadeira de sala',
      'poltrona cinza',
      'poltrona bege',
      'poltrona preta',
      'poltrona branca',
      'poltrona estampada',
    ],

    'mesa de centro': [
      'mesa centro',
      'mesa de sala',
      'mesinha sala',
      'mesa centro sala',
      'mesa oval sala',
      'mesa redonda sala',
      'mesa de centro sala',
      'mesa central',
      'mesa centro decorativa',
      'mesa de centro redonda',
      'mesa de centro oval',
      'mesa de centro retangular',
      'mesa de centro madeira',
      'mesa de centro vidro',
      'mesa de centro marmor',
      'mesa de centro mármore',
      'mesa de centro preto',
      'mesa de centro branca',
      'mesa de centro moderna',
      'center table',
      'coffee table',
    ],

    'mesa lateral': [
      'mesa de apoio',
      'mesinha lateral',
      'mesa auxiliar',
      'mesa apoio sofa',
      'mesa de apoio sofa',
      'mesinha de apoio',
      'mesa pequena lateral',
      'mesa lateral sala',
      'mesa lateral sofa',
      'mesa de canto sala',
      'mesa canto sofa',
      'mesa apoio cadeira',
      'mesa apoio poltrona',
      'side table',
      'mesinha redonda',
      'mesa apoio madeira',
      'mesa apoio metal',
    ],

    'rack': [
      'rack tv',
      'painel tv',
      'movel tv',
      'móvel tv',
      'rack televisao',
      'rack televisão',
      'painel televisao',
      'painel televisão',
      'rack sala',
      'bancada tv',
      'rack painel',
      'movel televisao',
      'móvel televisão',
      'rack e painel',
      'rack painel tv',
      'painel para tv',
      'rack para televisao',
      'movel para tv',
      'rack ripado',
      'rack suspenso',
      'rack flutuante',
      'painel ripado tv',
      'rack moderno',
      'rack madeira',
      'rack com gaveta',
      'rack com porta',
      'estante para tv',
      'movel para televisão sala',
      'rack tv sala',
    ],

    'estante': [
      'prateleira',
      'estante livros',
      'rack livros',
      'nicho parede',
      'estante escritorio',
      'estante sala',
      'biblioteca',
      'estante decorativa',
      'prateleiras parede',
      'estante de livros',
      'nicho decorativo',
      'nicho de parede',
      'estante alta',
      'estante baixa',
      'estante modular',
      'estante com portas',
      'estante com nichos',
      'estante madeira',
      'estante preta',
      'estante branca',
      'livreiro',
      'livreiro moderno',
      'livreiro madeira',
      'mini biblioteca',
      'organizador livros',
    ],

    'cama': [
      'cama casal',
      'cama solteiro',
      'cama queen',
      'cama king',
      'cama box',
      'cama casal queen',
      'cama casal king',
      'cama box casal',
      'cama box queen',
      'cama box king',
      'cama de casal',
      'cama de solteiro',
      'cama estofada',
      'cama com cabeceira',
      'cama de madeira',
      'cama ripada',
      'cama moderna',
      'cama boucle',
      'cama bouclé',
      'cama veludo',
      'cama cinza',
      'cama bege',
      'cama branca',
      'cama preta',
      'cama de casal queen',
      'cama de casal king',
      'cama box queen casal',
      'cama queen size',
      'cama king size',
      'cama americana',
    ],

    'cabeceira': [
      'cabeceira cama',
      'cabeceira casal',
      'cabeceira solteiro',
      'cabeceira queen',
      'cabeceira king',
      'headboard',
      'cabeceira de cama',
      'cabeceira estofada',
      'cabeceira painel',
      'cabeceira madeira',
      'cabeceira ripada',
      'cabeceira moderna',
      'cabeceira boucle',
      'cabeceira bouclé',
      'cabeceira veludo',
      'cabeceira de madeira',
      'cabeceira com nicho',
      'cabeceira com luz',
      'cabeceira iluminada',
      'cabeceira cinza',
      'cabeceira bege',
      'cabeceira branca',
    ],

    'mesa de cabeceira': [
      'mesinha quarto',
      'mesa lateral quarto',
      'mesa cabeceira',
      'mesinhas de cabeceira',
      'mesa de canto quarto',
      'mesa apoio quarto',
      'apoio cama',
      'mesa lateral cama',
      'criado mudo',
      'criado-mudo',
      'criado',
      'criados mudos',
      'mesinha de cabeceira',
      'mesa de cabeceira madeira',
      'mesa de cabeceira branca',
      'mesa de cabeceira preta',
      'criado mudo madeira',
      'criado mudo com gaveta',
      'criado mudo moderno',
      'mesinha ao lado da cama',
      'mesa pequena quarto',
    ],

    'guarda roupa': [
      'guarda-roupa',
      'armario',
      'armário',
      'closet',
      'roupeiro',
      'armario quarto',
      'guarda roupa casal',
      'guarda roupa solteiro',
      'guarda-roupa casal',
      'armário embutido',
      'wardrobe',
      'guarda roupa 3 portas',
      'guarda roupa 4 portas',
      'guarda roupa 6 portas',
      'guarda roupa com espelho',
      'guarda roupa moderno',
      'guarda roupa madeira',
      'guarda roupa branco',
      'guarda roupa planejado',
      'armario com espelho',
      'armário grande',
      'armario de quarto',
      'roupeiro moderno',
    ],

    'comoda': [
      'cômoda',
      'comoda quarto',
      'cômoda quarto',
      'gaveteiro',
      'comoda com espelho',
      'comoda 6 gavetas',
      'cômodas quarto',
      'comoda de quarto',
      'comoda madeira',
      'cômoda com espelho',
      'cômoda 3 gavetas',
      'cômoda 4 gavetas',
      'cômoda 5 gavetas',
      'cômoda 6 gavetas',
      'cômoda branca',
      'cômoda preta',
      'cômoda madeira',
      'cômoda moderna',
      'gaveteiro madeira',
      'gaveteiro quarto',
      'gaveteiro de quarto',
      'chest of drawers',
    ],

    'mesa de escritorio': [
      'mesa escritorio',
      'mesa home office',
      'mesa trabalho',
      'mesa computador',
      'mesa desk',
      'mesa pc',
      'escrivaninha',
      'mesa para escritorio',
      'mesa trabalho home',
      'mesa notebook',
      'mesa para computador',
      'mesa para notebook',
      'mesa gamer',
      'desk',
      'mesa escritório em l',
      'mesa em l escritorio',
      'mesa com gaveta escritorio',
      'mesa com prateleira escritorio',
      'mesa de escritorio madeira',
      'mesa de escritorio branca',
      'mesa de escritorio preta',
      'mesa para home office',
    ],

    'cadeira de escritorio': [
      'cadeira escritorio',
      'cadeira home office',
      'cadeira trabalho',
      'cadeira gamer',
      'poltrona escritorio',
      'cadeira ergonomica',
      'cadeira ergonômica',
      'cadeira office',
      'cadeira para escritorio',
      'cadeira giratoria',
      'cadeira giratória',
      'cadeira com rodinhas',
      'cadeira com apoio',
      'cadeira executiva',
      'office chair',
      'gaming chair',
      'cadeira de trabalho',
      'cadeira regulavel',
      'cadeira ajustavel',
    ],

    'tapete': [
      'tapete sala',
      'tapete quarto',
      'carpete',
      'passadeira',
      'tapete decorativo',
      'tapete grande',
      'tapete pequeno',
      'tapete shaggy',
      'tapete persa',
      'tapete geometrico',
      'tapete geométrico',
      'tapete pelo alto',
      'tapete de sala',
      'tapete redondo',
      'tapete oval',
      'tapete retangular',
      'tapete moderno',
      'tapete boho',
      'tapete minimalista',
      'tapete preto e branco',
      'tapete bege',
      'tapete cinza',
      'tapete estampado',
      'tapete listrado',
      'tapete para sala',
      'tapete para quarto',
      'tapete lavavel',
      'tapete lavável',
      'rug',
      'area rug',
    ],

    'puff': [
      'puf',
      'puff sala',
      'puff ottoman',
      'otomano',
      'puff grande',
      'puff pequeno',
      'banco puff',
      'pufe',
      'puff decorativo',
      'puf ottoman',
      'banco puf',
      'pouf',
      'puff redondo',
      'puff quadrado',
      'puff couro',
      'puff veludo',
      'puff tecido',
      'puff de sala',
      'banco estofado',
      'banco redondo',
      'ottoman',
      'foot stool',
    ],

    'aparador': [
      'aparador sala',
      'aparador entrada',
      'sideboard',
      'buffet',
      'bufê',
      'aparador buffet',
      'aparador de sala',
      'aparador moderno',
      'aparador madeira',
      'aparador decorativo',
      'cristaleira',
      'cristaleiras',
      'aparador branco',
      'aparador preto',
      'aparador de entrada',
      'aparador com gaveta',
      'aparador com porta',
      'aparador ripado',
      'aparador fino',
      'aparador sala de jantar',
      'movel aparador',
      'móvel aparador',
      'console',
      'console table',
    ],

    'luminaria': [
      'luminária',
      'abajur',
      'luminaria mesa',
      'luminaria de chao',
      'luminária de chão',
      'iluminacao',
      'iluminação',
      'luminaria decorativa',
      'luz decorativa',
      'luminaria abajur',
      'abajur de mesa',
      'luminária de mesa',
      'floor lamp',
      'luminaria chao',
      'luminaria de piso',
      'luminária de piso',
      'abajur de chão',
      'luminaria moderna',
      'luminária moderna',
      'lamp',
      'table lamp',
      'luminaria para sala',
      'luminaria para quarto',
    ],

    'pendente': [
      'lustre',
      'pendente sala',
      'pendente cozinha',
      'pendente ilha',
      'luminaria teto',
      'lustre sala',
      'chandelier',
      'lustre pendente',
      'luminaria pendente',
      'luminária pendente',
      'luminária de teto',
      'lustre moderno',
      'lustre de teto',
      'luminaria de teto',
      'pendente moderno',
      'pendente metal',
      'pendente madeira',
      'pendente preto',
      'pendente dourado',
      'pendente cobre',
      'ceiling lamp',
      'pendant light',
      'hanging lamp',
    ],

    'espelho': [
      'espelho sala',
      'espelho quarto',
      'espelho banheiro',
      'espelho decorativo',
      'espelho parede',
      'espelho redondo',
      'espelho oval',
      'espelho grande',
      'espelho de parede',
      'espelho com moldura',
      'espelho sem moldura',
      'espelho dourado',
      'espelho preto',
      'espelho arco',
      'espelho arco dourado',
      'espelho retangular',
      'espelho arquitetônico',
      'espelho organico',
      'espelho orgânico',
      'mirror',
      'espelho corpo inteiro',
      'espelho de chão',
      'full length mirror',
    ],

    'quadro decorativo': [
      'quadro',
      'pintura',
      'arte parede',
      'decoracao parede',
      'decoração parede',
      'poster',
      'tela decorativa',
      'quadro para sala',
      'quadro moderno',
      'quadros parede',
      'quadro abstrato',
      'quadro botanico',
      'quadro botânico',
      'quadro minimalista',
      'quadro preto e branco',
      'quadro colorido',
      'quadro para quarto',
      'gallery wall',
      'painel decorativo',
      'tela pintada',
      'impressao decorativa',
      'impressão decorativa',
      'canvas print',
      'art print',
    ],

    'vaso decorativo': [
      'vaso',
      'vaso flores',
      'cachepot',
      'vaso grande',
      'vaso ceramica',
      'vaso cerâmica',
      'vaso decoracao',
      'vaso para flores',
      'vasos decorativos',
      'vaso de decoração',
      'vaso branco',
      'vaso preto',
      'vaso bege',
      'vaso terroso',
      'vaso alto',
      'vaso redondo',
      'vaso de cerâmica',
      'vaso artesanal',
      'vaso minimalista',
      'cachepô',
      'vaso de chão',
      'flower vase',
      'planter',
    ],

    'almofada': [
      'capa almofada',
      'cushion',
      'coxim',
      'almofada sofa',
      'almofada decorativa',
      'almofada cama',
      'travesseiro decorativo',
      'almofadas decorativas',
      'capa de almofada',
      'kit almofadas',
      'conjunto almofadas',
      'almofada grande',
      'almofada pequena',
      'almofada quadrada',
      'almofada redonda',
      'almofada bordada',
      'almofada estampada',
      'almofada veludo',
      'almofada linho',
      'almofada boucle',
      'almofada de sofa',
      'throw pillow',
      'pillow cover',
      'decorative cushion',
    ]
  };


  /* ================================================================
     NORMALIZAÇÃO DE TEXTO
  ================================================================ */
  function normalize(str) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^\w\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* ================================================================
     EXPANSÃO DE QUERY — mapeia variação orgânica → termo canônico
  ================================================================ */
  function expandQuery(query) {
    const norm = normalize(query);
    if (norm.length < 3) return query;

    for (const [canonical, aliases] of Object.entries(SYNONYMS)) {
      const normCanonical = normalize(canonical);

      if (norm === normCanonical) return canonical;
      if (aliases.some(a => normalize(a) === norm)) return canonical;
    }

    return query;
  }

  /* ================================================================
     DICA DE SINÔNIMO — retorna sugestão "Você quis dizer?" ou null
     Matching: query contém o termo OU candidate começa com a query (prefixo simples)
  ================================================================ */
  function getSuggestion(query = '') {
    const norm = normalize(query);
    if (norm.length < 3) return null;

    function matches(candidate, q) {
      // query contém o candidate completo (ex: "mesa com cadeiras" bate "cadeiras")
      if (q.includes(candidate)) return true;
      // candidate começa com a query — prefixo simples, sem exigir fim de palavra
      // ex: q="cadei" bate candidate="cadeira", q="mes" bate "mesa de jantar"
      if (candidate.startsWith(q)) return true;
      return false;
    }

    for (const [category, synonyms] of Object.entries(SYNONYMS)) {
      const normCat = normalize(category);
      if (matches(normCat, norm)) {
        return category.charAt(0).toUpperCase() + category.slice(1);
      }
      for (const synonym of synonyms) {
        if (matches(normalize(synonym), norm)) {
          return category.charAt(0).toUpperCase() + category.slice(1);
        }
      }
    }

    return null;
  }

  /* ================================================================
     UTILITÁRIOS
  ================================================================ */
  function formatPrice(price) {
    const value = typeof price === 'string' ? parseFloat(price) : Number(price);
    if (isNaN(value) || value <= 0) return '';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }

  function getImageUrl(url, width = 128) {
    if (!url) return null;
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}width=${width}`;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function highlight(text, query) {
    const safeText = escapeHtml(text);
    const normText = normalize(text);
    const normQuery = normalize(query);
    if (!normQuery || normQuery.length < 2) return safeText;
    const idx = normText.indexOf(normQuery);
    if (idx === -1) return safeText;
    const pre = safeText.slice(0, idx);
    const match = safeText.slice(idx, idx + normQuery.length);
    const post = safeText.slice(idx + normQuery.length);
    return `${pre}<mark>${match}</mark>${post}`;
  }

  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  /* ================================================================
     CLASSE PRINCIPAL — SearchDrawer
  ================================================================ */
  class SearchDrawer {
    constructor(el) {
      this.el = el;
      this.panel = el.querySelector('[data-sd-panel]');
      this.overlay = el.querySelector('[data-sd-overlay]');
      this.input = el.querySelector('[data-sd-input]');
      this.clearBtn = el.querySelector('[data-sd-clear]');
      this.closeBtn = el.querySelector('[data-sd-close]');

      this.stateDefault = el.querySelector('[data-sd-state="default"]');
      this.stateLoading = el.querySelector('[data-sd-state="loading"]');
      this.stateResults = el.querySelector('[data-sd-state="results"]');
      this.stateEmpty = el.querySelector('[data-sd-state="empty"]');
      this.emptyTerm = el.querySelector('[data-sd-empty-term]');

      this.footer = el.querySelector('[data-sd-footer]');
      this.viewAllLink = el.querySelector('[data-sd-view-all]');

      this.isOpen = false;
      this.currentQuery = '';
      this.abortCtrl = null;
      this.cache = new Map();
      this.activeIndex = -1;

      this._debouncedSearch = debounce(this._search.bind(this), 50);

      this._bindEvents();
    }

    /* ── Prefetch — aquece a conexão com a API ao hover ─── */
    _prefetch() {
      if (this._prefetched) return;
      this._prefetched = true;
      fetch('/search/suggest.json?q=&resources[type]=product&resources[limit]=1', {
        priority: 'low',
        headers: { 'Content-Type': 'application/json' }
      }).catch(() => {});
    }

    /* ── Eventos ─────────────────────────────────────────── */
    _bindEvents() {
      // Todos os botões trigger na página
      document.querySelectorAll('[data-search-drawer-trigger]').forEach(btn => {
        btn.addEventListener('click', () => {
          const prefill = btn.dataset.searchTerm || '';
          if (this.isOpen) {
            this.close();
          } else {
            this.open(prefill);
          }
        });
        btn.addEventListener('mouseenter', () => this._prefetch());
        btn.addEventListener('touchstart', () => this._prefetch(), { passive: true });
      });

      this.closeBtn?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());

      // Fecha ao clicar fora do painel (qualquer área da página)
      document.addEventListener('click', e => {
        if (!this.isOpen) return;
        if (this.panel?.contains(e.target)) return;
        if (e.target.closest('[data-search-drawer-trigger]')) return;
        this.close();
      }, true);

      this.input?.addEventListener('input', e => {
        const val = e.target.value;
        this._toggleClear(val.length > 0);
        this._debouncedSearch(val);
      });

      this.clearBtn?.addEventListener('click', () => {
        this.input.value = '';
        this._toggleClear(false);
        this._showState('default');
        this.currentQuery = '';
        this.input.focus();
      });

      // Buscas populares → navega diretamente para a página de resultados
      this.el.querySelectorAll('[data-sd-popular]').forEach(btn => {
        btn.addEventListener('click', e => {
          const term = e.currentTarget.dataset.sdPopular;
          window.location.href = `/search?q=${encodeURIComponent(term)}&type=product`;
        });
      });

      // Delegação de clique para "Você quis dizer?" → navega para resultados
      this.el.addEventListener('click', e => {
        const btn = e.target.closest('[data-sd-suggestion]');
        if (!btn) return;
        window.location.href = `/search?q=${encodeURIComponent(btn.dataset.sdSuggestion)}&type=product`;
      });

      // Keyboard global
      document.addEventListener('keydown', e => {
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
          e.preventDefault();
          this.isOpen ? this.close() : this.open();
        }
        if (e.key === 'Escape' && this.isOpen) this.close();
        if (!this.isOpen) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); this._moveActive(1); }
        if (e.key === 'ArrowUp') { e.preventDefault(); this._moveActive(-1); }
        if (e.key === 'Enter') {
          if (this.activeIndex >= 0) {
            this._selectActive();
          } else if (this.currentQuery) {
            window.location.href = `/search?q=${encodeURIComponent(this.currentQuery)}&type=product`;
          }
        }
      });

      // Trap foco dentro do painel
      this.panel?.addEventListener('keydown', e => {
        if (e.key === 'Tab') this._trapFocus(e);
      });
    }

    /* ── Abrir / fechar ──────────────────────────────────── */
    open(prefill = '') {
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('search-drawer-open');
      this.isOpen = true;
      if (this.emptyTerm) this.emptyTerm.textContent = '';
      this._renderRecentlyViewed();
      requestAnimationFrame(() => {
        setTimeout(() => {
          if (this.input) {
            this.input.focus();
            if (prefill) {
              this.input.value = prefill;
              this._toggleClear(true);
              this._debouncedSearch(prefill);
            }
          }
        }, 60);
      });
    }

    _renderRecentlyViewed() {
      const section = this.el.querySelector('[data-sd-recently-viewed]');
      const list = this.el.querySelector('[data-sd-rv-list]');
      if (!section || !list) return;

      try {
        const items = JSON.parse(localStorage.getItem('dawn_recently_viewed') || '[]');
        if (items.length === 0) { section.hidden = true; return; }

        const isDesktop = window.matchMedia('(min-width: 750px)').matches;
        const limit = isDesktop ? 6 : 8;
        const imgSize = isDesktop ? 240 : 160;

        list.innerHTML = items.slice(0, limit).map(item => `
          <li class="search-drawer__rv-card">
            <a href="${escapeHtml(item.url)}" class="search-drawer__rv-link">
              <div class="search-drawer__rv-img-wrap">
                ${item.image
                  ? `<img src="${escapeHtml(getImageUrl(item.image, imgSize))}" alt="${escapeHtml(item.title)}" class="search-drawer__rv-img" loading="lazy" width="140" height="140" decoding="async">`
                  : `<div class="search-drawer__product-img-placeholder"></div>`
                }
              </div>
              <div class="search-drawer__rv-info">
                <p class="search-drawer__rv-title">${escapeHtml(item.title)}</p>
                ${item.pix_price
                  ? `<div class="search-drawer__rv-price-wrap">
                      ${item.price ? `<span class="search-drawer__rv-price--compare">${escapeHtml(item.price)}</span><span class="search-drawer__rv-price-sep">—</span>` : ''}
                      <span class="search-drawer__rv-pix-price">${escapeHtml(item.pix_price)} <span class="search-drawer__rv-pix-badge">no PIX</span></span>
                    </div>`
                  : item.price
                    ? `<p class="search-drawer__rv-price">${escapeHtml(item.price)}</p>`
                    : ''
                }
              </div>
            </a>
          </li>
        `).join('');

        section.hidden = false;
      } catch(e) {
        section.hidden = true;
      }
    }

    close() {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('search-drawer-open');
      this.isOpen = false;
      this.activeIndex = -1;
    }

    /* ── Controle de estado visual ───────────────────────── */
    _showState(state) {
      [
        ['default', this.stateDefault],
        ['loading', this.stateLoading],
        ['results', this.stateResults],
        ['empty', this.stateEmpty]
      ].forEach(([key, el]) => {
        if (!el) return;
        el.hidden = key !== state;
      });

      if (this.footer) {
        this.footer.hidden = state !== 'results';
      }
    }

    _toggleClear(show) {
      if (this.clearBtn) this.clearBtn.hidden = !show;
    }

    /* ── Busca ───────────────────────────────────────────── */
    async _search(raw) {
      const query = raw.trim();

      if (!query) {
        this._showState('default');
        this.currentQuery = '';
        return;
      }

      if (query === this.currentQuery) return;
      this.currentQuery = query;

      const expanded = expandQuery(query);
      const cacheKey = normalize(expanded);

      if (this.cache.has(cacheKey)) {
        this._render(this.cache.get(cacheKey), query);
        return;
      }

      this._showState('loading');

      if (this.abortCtrl) this.abortCtrl.abort();
      this.abortCtrl = new AbortController();

      try {
        const params = new URLSearchParams({
          q: expanded,
          'resources[type]': 'product,query,collection',
          'resources[limit]': '6',
          'resources[options][fields]': 'title,product_type,vendor,variants.title',
          'resources[options][unavailable_products]': 'last'
        });

        const res = await fetch(`/search/suggest.json?${params}`, {
          signal: this.abortCtrl.signal,
          headers: { 'Content-Type': 'application/json' }
        });

        if (!res.ok) throw new Error(`Search HTTP ${res.status}`);

        const data = await res.json();
        const results = data?.resources?.results ?? {};

        this.cache.set(cacheKey, results);
        this._render(results, query);
      } catch (err) {
        if (err.name === 'AbortError') return;
        this._showState('empty');
      }
    }

    /* ── Renderização dos resultados ─────────────────────── */
    _render(results, query) {
      const queries = results.queries ?? [];
      const collections = results.collections ?? [];
      const products = results.products ?? [];

      // Filtrar sugestões de texto que parecem slugs de URL (ex: "mesa-jantar-avena")
      const isReadable = (text) => text.includes(' ') || !/-/.test(text);
      const cleanQueries = queries.filter(q => isReadable(q.text));
      // Coleções da API não são exibidas — podem apontar para páginas com 0 produtos

      const hasQueries = cleanQueries.length > 0;
      const hasProducts = products.length > 0;

      if (!hasQueries && !hasProducts) {
        this._showEmpty(query);
        return;
      }

      let html = '';

      // ── Banner "Você quis dizer?" ──
      const hint = getSuggestion(query);
      if (hint) {
        const safeHint = escapeHtml(hint);
        html += `<div class="search-drawer__did-you-mean">
          Você quis dizer:
          <button type="button" class="search-drawer__did-you-mean-link" data-sd-suggestion="${safeHint}">
            ${safeHint}
          </button>?
        </div>`;
      }

      // ── Sugestões de busca e coleções ──
      if (hasQueries) {
        html += `<div class="search-drawer__result-group">
          <p class="search-drawer__result-group-title">Sugestões</p>
          <ul class="search-drawer__queries-list" role="group">`;

        cleanQueries.slice(0, 6).forEach((q, i) => {
          html += `<li>
            <a href="${escapeHtml(q.url)}"
               class="search-drawer__query-link"
               role="option"
               id="sd-q${i}"
               tabindex="-1">
              <svg class="search-drawer__query-icon" aria-hidden="true" viewBox="0 0 18 18" fill="none">
                <circle cx="7.5" cy="7.5" r="6" stroke="currentColor" stroke-width="1.2"/>
                <path d="M12 12l3.5 3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
              </svg>
              <span class="search-drawer__query-text">${highlight(q.text, query)}</span>
            </a>
          </li>`;
        });

        html += `</ul></div>`;
      }

      // ── Produtos ──
      if (hasProducts) {
        html += `<div class="search-drawer__result-group">
          <p class="search-drawer__result-group-title">Produtos</p>
          <ul class="search-drawer__products-list" role="group">`;

        products.slice(0, 6).forEach((p, i) => {
          const imgUrl = getImageUrl(p.featured_image?.url, 300);
          const imgAlt = escapeHtml(p.featured_image?.alt || p.title);
          const priceStr = p.price !== undefined ? formatPrice(p.price) : '';
          const pixPrice = p.price !== undefined ? formatPrice(p.price * 0.9) : '';

          html += `<li>
            <a href="${escapeHtml(p.url)}"
               class="search-drawer__product-link"
               role="option"
               id="sd-p${i}"
               tabindex="-1">
              <div class="search-drawer__product-img-wrap">
                ${imgUrl
                  ? `<img class="search-drawer__product-img"
                          src="${escapeHtml(imgUrl)}"
                          alt="${imgAlt}"
                          loading="lazy">`
                  : `<div class="search-drawer__product-img-placeholder" aria-hidden="true"></div>`
                }
              </div>
              <div class="search-drawer__product-info">
                ${p.type ? `<p class="search-drawer__product-type">${escapeHtml(p.type)}</p>` : ''}
                <p class="search-drawer__product-title">${escapeHtml(p.title)}</p>
                ${pixPrice
                  ? `<div class="search-drawer__product-price-wrap">
                      ${priceStr ? `<span class="search-drawer__product-price--compare">${priceStr}</span><span class="search-drawer__product-price-sep">—</span>` : ''}
                      <span class="search-drawer__product-pix-price">${pixPrice} <span class="search-drawer__product-pix-badge">no PIX</span></span>
                    </div>`
                  : priceStr
                    ? `<p class="search-drawer__product-price">${priceStr}</p>`
                    : ''
                }
              </div>
            </a>
          </li>`;
        });

        html += `</ul></div>`;
      }

      this.stateResults.innerHTML = html;
      this._showState('results');

      // Atualiza link "Ver todos"
      if (this.viewAllLink) {
        this.viewAllLink.href = `/search?q=${encodeURIComponent(query)}&type=product`;
      }

      this.activeIndex = -1;
    }

    _showEmpty(query) {
      const display = (query || this.currentQuery || '').trim();
      if (this.emptyTerm) this.emptyTerm.textContent = display;

      const hintEl = this.el.querySelector('[data-sd-empty-hint]');
      if (hintEl) {
        const hint = getSuggestion(query);
        if (hint) {
          const safeHint = escapeHtml(hint);
          hintEl.innerHTML = `Você quis dizer: <button type="button" class="search-drawer__did-you-mean-link" data-sd-suggestion="${safeHint}">${safeHint}</button>?`;
          hintEl.hidden = false;
        } else {
          hintEl.hidden = true;
        }
      }

      this._showState('empty');
    }

    /* ── Navegação por teclado ───────────────────────────── */
    _getSelectables() {
      if (this.stateResults.hidden) return [];
      return Array.from(this.stateResults.querySelectorAll('[role="option"]'));
    }

    _moveActive(dir) {
      const items = this._getSelectables();
      if (!items.length) return;

      const prev = items[this.activeIndex];
      if (prev) prev.setAttribute('aria-selected', 'false');

      this.activeIndex = Math.max(0, Math.min(items.length - 1, this.activeIndex + dir));

      const next = items[this.activeIndex];
      if (next) {
        next.setAttribute('aria-selected', 'true');
        next.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    _selectActive() {
      const items = this._getSelectables();
      const active = items[this.activeIndex];
      if (active) active.click();
    }

    /* ── Trap de foco ────────────────────────────────────── */
    _trapFocus(e) {
      const focusables = Array.from(
        this.panel.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])')
      ).filter(el => !el.hidden && el.offsetParent !== null);

      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  /* ================================================================
     BARRA INLINE — scroll listener próprio (independente do StickyHeader)
     Mostra a barra no load, esconde quando rolar > 60px
  ================================================================ */
  function initInlineSearchBar() {
    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return;

    let ticking = false;
    const THRESHOLD = 60;

    function update() {
      if (window.scrollY > THRESHOLD) {
        sectionHeader.classList.add('hd-scrolled');
      } else {
        sectionHeader.classList.remove('hd-scrolled');
      }
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ================================================================
     INICIALIZAÇÃO
  ================================================================ */
  function init() {
    const el = document.getElementById('search-drawer');
    if (el) {
      const drawer = new SearchDrawer(el);
      if (new URLSearchParams(window.location.search).get('open-search') === '1') {
        setTimeout(() => drawer.open(), 120);
      }
    }
    initInlineSearchBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
